{
  "endTime": "Hora de finalización",
  "startTime": "Hora de inicio",
  "time": "Hora"
}
